import { useSelector } from "react-redux";
import { Reducers } from "../redux/reducers";
import UserInformation from "../types/UserInformation";
import CheckAttr from "./CheckAttr";

const urlBaseApi = process.env.REACT_APP_BASE_API_URL as string;

/**
 * @returns
 * Recupère l'information de l'utilisateur connecté
 */
export const ConnectedUser = (): UserInformation => {
    const logger = useSelector<Reducers>((state) => state.logger) as UserInformation;

    return logger;
};

/**
 * @param filename 
 * Telecharge un fichier
 */
export const downloadFile = (filename: string): void => {
    const url = `${urlBaseApi}down/excel/${filename}`;
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
};

/**
 * @param filename
 * Telecharge manuel d'utilisateur
 */
export const downloadManualUserFile = (filename: string) => {
    let baseUrl = urlBaseApi;

    if (baseUrl.includes('api/')) {
        baseUrl = urlBaseApi.substring(0, (baseUrl.length - 4));
    }

    const url = `${baseUrl}manual_user/${filename}`;

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
};

export const convertBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
            resolve(fileReader.result);
        };
        fileReader.onerror = (error) => {
            reject(error);
        };
    });
};

export const dateToString = (date: Date): string => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    return `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
}

export const checkViaCodeArticle = (tab1: string[], tab2: string[], codeArticle?: string) => {
    if (codeArticle && tab2.includes(codeArticle.charAt(codeArticle.length - 1))) {
        return true;
    }

    return false;
};

export const calculCABudget = (quantity: any, prixUnitaire: any): string | null => {
    const nb1 = CheckAttr(quantity) ? Number(String(quantity).replace(",", ".")) : null;
    const nb2 = CheckAttr(prixUnitaire) ? Number(String(prixUnitaire).replace(",", ".")) : null;

    let res = null;
    if (CheckAttr(nb1) && nb1 !== null  && CheckAttr(nb2) && nb2 !== null) {
        res = (nb1 * nb2).toFixed(2);
    }

    return res;
};

export const calculCoutBudget = (heure_cout_budget: any, cout_activite: any): string | null => {
    const nb1 = CheckAttr(heure_cout_budget) ? Number(String(heure_cout_budget).replace(",", ".")) : null;
    const nb2 = CheckAttr(cout_activite) ? Number(String(cout_activite).replace(",", ".")) : null;

    let res = null;
    if (CheckAttr(nb1) && nb1 !== null  && CheckAttr(nb2) && nb2 !== null) {
        res = (nb1 * nb2).toFixed(2);
    }

    return res;
};

export const calculTauxMargeBudget = (marge_valeur_budget: any, ca_budget: any): number | null => {
    const nb1 = CheckAttr(marge_valeur_budget) ? Number(String(marge_valeur_budget).replace(",", ".")) : null;
    const nb2 = CheckAttr(ca_budget) ? Number(String(ca_budget).replace(",", ".")) : null;

    let res = null;
    if (CheckAttr(nb1) && nb1 !== null  && CheckAttr(nb2) && nb2 !== null) {
        res = Number((nb1 / nb2).toFixed(2));
    }

    return res;
};

export const calculMargeValeurBudget = (ca_budget: any, cout_budget: any): string | null => {
    const CaBudget = CheckAttr(ca_budget) ? Number(String(ca_budget).replace(",", ".")) : null;
    const coutBudget = CheckAttr(cout_budget) ? Number(String(cout_budget).replace(",", ".")) : null;

    let res = '';

    if (CheckAttr(CaBudget) && CaBudget!==null  && CheckAttr(coutBudget) && coutBudget!==null) {
        res = (CaBudget - coutBudget).toFixed(2);
    }

    return res;
};

export const calculQuantityBudget = (ca_budget: any, tarif: any): string | null => {
    const nb1 = CheckAttr(ca_budget) ? Number(String(ca_budget).replace(",", ".")) : null;
    const nb2 = CheckAttr(tarif) ? Number(String(tarif).replace(",", ".")) : null;

    let result = null;

    if (CheckAttr(nb1) && nb1 !== null  && CheckAttr(nb2) && nb2 !== null) {
        result = (nb1 / nb2).toFixed(2);
    }

    return result;
}

export const calculHeureProductionBudget = (ca_budget: any, tx_marge_budget: any, cout_activite: any): string | null => {
    const nb1 = CheckAttr(ca_budget) ? Number(String(ca_budget).replace(",", ".")) : null;
    const nb2 = CheckAttr(tx_marge_budget) ? Number(String(tx_marge_budget).replace(",", ".")) : null;
    const nb3 = CheckAttr(cout_activite) ? Number(String(cout_activite).replace(",", ".")) : null;

    let marge_budget = null;
    if (CheckAttr(nb1) && nb1 !== null  && CheckAttr(nb2) && nb2 !== null) {
        marge_budget = nb1 * nb2;
    }

    let coutBudget = null;
    if (CheckAttr(nb1) && nb1 !== null && marge_budget) {
        /**
         * Cout budget = somme CA BUDGET / marge budget
         */
        coutBudget = nb1 - marge_budget;
    }

    let result = null;
    if (coutBudget && nb3) {
        /**
         * Heure prod budget = Coût Budget / Coût/h
         */
        result = String((coutBudget / nb3).toFixed(2));
    }

    return result;
}